// 重置
export function validatereset(e: any, id: number) {
  let validate = '';
  const passTest = /[a-zA-Z]+(?=\d+)|\d+(?=[a-zA-Z]+)/g;
  if (e.password.length < 6 && id === 3) {
    validate = '密码字符不得低于6位';
  } else if (!passTest.test(e.password) && id === 3) {
    validate = '密码格式为数字加字母';
  } else if (e.password !== e.newpassword && id === 3) {
    validate = '两次输入的密码不一致';
  }
  return validate;
}
